<template>
  <loading-overlay v-if="loading" class="animated fadeIn"></loading-overlay>
  <div class="animated fadeIn" v-else>
    <default-heading class="mt-3">
      My Team ({{ authenticated_customer_name }})

      <template v-slot:right>
        <b-button variant="success" to="team/edit">
          <i class="fal fa-pencil" />
        </b-button>
      </template>
    </default-heading>

    <CustomerCard :customer="customer" />

    <div class="my-4"></div>

    <CustomerDetailCardstack :contacts="contacts" :locations="locations" />
  </div>
</template>

<script>
import CustomerCard from '@/components/crm/customer/CustomerCard.vue';
import CustomerDetailCardstack from "@/components/crm/customer/CustomerDetailCardstack.vue";
import DefaultHeading from "@/components/shared/DefaultHeading";
import LoadingOverlay from "@/components/shared/LoadingOverlay";
import CustomerModel from "@/models/crm/CustomerModel";

export default {
  components: {
    LoadingOverlay,
    DefaultHeading,
    CustomerDetailCardstack,
    CustomerCard
  },
  name: "TeamIndex",
  data() {
    return {
      authenticated_customer_id: this.$store.getters.getAuthCustomerID || null,
      authenticated_customer_name:
        this.$store.getters.getAuthCustomerName || null,
      customer: null,
      contacts: null,
      locations: null,
      loading: true
    };
  },
  methods: {
    fetch() {
      return new Promise((resolve, reject) => {
        if (this.authenticated_customer_id) {
          let customer = new CustomerModel({
            id: this.authenticated_customer_id
          });
          customer.fetch({ params: { connection: ['customer_locations'] } }).then(() => {
            this.customer = customer;
            this.contacts = customer.getCustomerContacts();
            this.locations = customer.getCustomerLocations();
            resolve(this.customer);
          });
        }
      });
      /*this.contacts = [];
        this.locations = [];
        return CustomersRepository.get(this.authenticated_customer_id).then((response) => {
          if(response && response.status === 200 && response.data) {
            const customer = response.data;
            this.contacts = customer.customer_contacts;
            this.locations = customer.customer_locations;
          }
        });*/
    }
  },
  mounted() {
    this.loading = true;
    this.fetch().then(() => {
      this.loading = false;
    });
  }
};
</script>
